module.exports = __webpack_public_path__ + "img/star2yellow.20cd8f9c.png";